import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';

export class DeviceProcessDataEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;
    return {
      entity: new DeviceProcessDataEntity(
        parseInt(attrs[ATTRS.DeviceProcessData.DeviceProcessDataObjectId], 10),
        attrs[ATTRS.DeviceProcessData.DeviceProcessDataDDI],
        parseInt(attrs[ATTRS.DeviceProcessData.DeviceProcessDataProperty], 10),
        parseInt(attrs[ATTRS.DeviceProcessData.DeviceProcessDataTriggerMethods], 10),
        attrs[ATTRS.DeviceProcessData.DeviceProcessDataDesignator],
        attrs[ATTRS.DeviceProcessData.DeviceValuePresentationObjectId]
          ? parseInt(attrs[ATTRS.DeviceProcessData.DeviceValuePresentationObjectId], 10)
          : null
      ),
    };
  }
  public type = TAGS.DeviceProcessData;

  constructor(
    public objectId: number,
    public DDI: string,
    public dataProperty: number,
    public dataTriggerMethods: number,
    public designator?: string,
    public deviceValuePresentationObjectId?: number
  ) {}

  public toXML() {
    return {
      _attributes: {
        [ATTRS.DeviceProcessData.DeviceProcessDataObjectId]: this.objectId,
        [ATTRS.DeviceProcessData.DeviceProcessDataDDI]: this.DDI,
        [ATTRS.DeviceProcessData.DeviceProcessDataProperty]: this.dataProperty,
        [ATTRS.DeviceProcessData.DeviceProcessDataTriggerMethods]: this.dataTriggerMethods,
        [ATTRS.DeviceProcessData.DeviceProcessDataDesignator]: this.designator,
        [ATTRS.DeviceProcessData.DeviceValuePresentationObjectId]:
          this.deviceValuePresentationObjectId,
      },
    };
  }
}
